/* Component Dependencies */
var hotelHighlightsTemplate = require('templates/hotelHighlights.hbs');
var hotelHighlightsLocalAreaTemplate = require('templates/hotelHighlights-localArea.hbs');
var hotelHighlightsVenueTemplate = require('templates/hotelHighlights-venue.hbs');
var hotelHighlightsGuestRoomTemplate = require('templates/hotelHighlights-guestRoom.hbs');
var AriesComponent = require('libs/aries-component');

AriesComponent.create({
  type: 'hotelHighlights',
  template: {
    'hotelHighlights': hotelHighlightsTemplate,
    'hotelHighlights-localArea': hotelHighlightsLocalAreaTemplate,
    'hotelHighlights-venue': hotelHighlightsVenueTemplate,
    'hotelHighlights-guestRoom': hotelHighlightsGuestRoomTemplate
  },
  bindEvents: function() {
    var _self = this;
    _self.hideSeparator();
  },
  hideSeparator: function() {
    var _self = this,
      $propMessageTile = $('.tile-property-message'),
      $separator = $('.l-separator');

    if (!$propMessageTile.length) {
      $separator.removeClass('l-display-none');
      $separator.addClass('l-display-none');
    }
  }
});
